import { Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { MibButtonComponent, MibIconsModule } from '@medinbox/angular';
import { MibLogo } from '../../mib-header/mib-logo';

@Component({
  selector: 'mai-cancel-dialog',
  imports: [MibLogo, MibButtonComponent, MibIconsModule],
  templateUrl: './declined-dialog.html',
})
export class DeclinedDialog {
  readonly dialogRef = inject(DialogRef<void>);
}
